export default __webpack_public_path__ + "static/media/cytocaare-banner-06.778a19c3.jpg";